module.exports = __webpack_public_path__ + "img/homepage.392a04f2.png";